import React from 'react';
import PropTypes from 'prop-types';

const WrestlingPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M28.887 24.753c-1.107-.613-2.513-1.593-3.364-2.206-.261-.188-.604-.737-.673-1.387-.114-1.09-.28-2.687-.375-3.369-.092-.645-.705-.201-1.767.435-1.058.636-.879.444-1.323.87-.417 2.27-.883 4.627-.883 6.092 0 .595-1.877.893-1.767-.435.192-2.275.316-3.703.44-6.092.04-.77 1.574-1.996 2.645-2.61.352-.169.943-.585.44-1.304-.935-1.35-1.081-2.124-2.207-.87-1.273 1.42-1.538 1.85-2.087 1.502-.627-.394-1.13-.897-1.003-1.067.582-.764 3.653-4.829 3.918-5.186.261-.357 1.145-.773 1.822-.032.508.559 2.197 2.88 3.26 4.239.53.682.562 2.398.562 2.719v4.788c1.012.892 2.362 1.895 3.237 2.609.723.586-.307 1.62-.875 1.304zm-12.354-6.962c-1.474-1.158-3.612-2.645-4.852-3.479-.16-.105-1.066.362-1.767.87 0 .444.05.939.884 1.74a10.836 10.836 0 0 1 1.766 2.174c.426.686 2.61 5.071 2.646 6.138.018.536-1.437.7-1.767 0-.723-1.547-1.597-3.58-2.206-4.394-.636-.76-1.877-2.211-3.264-3.1-.42 0-.901-.242-1.02.605-.138.975-.568 3.543-.568 3.8-.06.38-2.948 2.192-3.973 2.608-.348-.05-.732-1.593.027-2.037 1.122-.645 2.18-1.135 2.18-1.876v-4.184c0-.76.375-2.023.869-2.348 1.973-1.296 3.877-2.76 4.435-3.035.22-.11 1.222-.293 1.753-.004 2.884 2.636 4.413 3.877 6.62 5.657.443.394-1.25 1.286-1.763.865zM18.739 6c.975 0 1.767.778 1.767 1.74 0 .96-.792 1.739-1.767 1.739-.975 0-1.767-.778-1.767-1.74 0-.96.792-1.739 1.767-1.739zm-3.973 2.61c.975 0 1.767.777 1.767 1.738 0 .962-.792 1.74-1.767 1.74-.975 0-1.767-.778-1.767-1.74 0-.956.792-1.739 1.767-1.739z"
    />
  );
};

WrestlingPath.propTypes = {
  fill: PropTypes.string,
};

export default WrestlingPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/wrestling.jsx